import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { useAppBarStore } from "src/store/appBar.store";
export const appBarHeight = 64;
const AppBar = (param)=>{
    let { items , activeKey , className  } = param;
    const { isVisible , setIsVisible  } = useAppBarStore();
    const scrollVisible = useScrollVisibility({
        mode: "direction"
    });
    // 훅의 상태를 store에 동기화
    useEffect(()=>{
        setIsVisible(scrollVisible);
    }, [
        scrollVisible,
        setIsVisible
    ]);
    return /*#__PURE__*/ _jsx(motion.nav, {
        initial: {
            y: 0
        },
        animate: {
            y: isVisible ? 0 : appBarHeight
        },
        transition: {
            duration: 0.2,
            ease: "easeInOut"
        },
        className: cn("fixed bottom-0 left-0 right-0 z-app-bar h-16 border-t border-gray-100 bg-white lg:hidden", className),
        children: /*#__PURE__*/ _jsx("ul", {
            className: "mx-auto flex h-full max-w-[900px] items-center justify-around",
            children: items.map((item)=>{
                const isActive = activeKey === item.key;
                return /*#__PURE__*/ _jsx("li", {
                    className: "flex-1",
                    children: /*#__PURE__*/ _jsxs("button", {
                        type: "button",
                        onClick: ()=>{
                            var _item_onClick;
                            mixpanelEvent("App Bar Button Clicked", {
                                "Button Name": item.label,
                                "Button Url": item.url || ""
                            });
                            (_item_onClick = item.onClick) === null || _item_onClick === void 0 ? void 0 : _item_onClick.call(item);
                        },
                        className: cn("flex w-full flex-col items-center justify-center gap-1 py-2", isActive ? "text-primary-main [&_svg_path]:fill-primary-main" : "text-primary [&_svg_path]:fill-primary"),
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "flex h-6 w-6 items-center justify-center",
                                children: item.icon
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "label",
                                children: item.label
                            })
                        ]
                    })
                }, item.key);
            })
        })
    });
};
export default AppBar;
